<div class="mb-3">
  <form [formGroup]="timeGroup" (submit)="generateQuery(timeGroup.value)">
    <div class="row">
      <div class="col-12 col-md-6 d-flex flex-wrap" style="gap: 20px">
        <div>
          <label>
            <input
              type="radio"
              formControlName="dateOption"
              value="last24"
              (change)="generateQuery(timeGroup.value,true);"
            />
            {{ "time-query.last-24-hours" | translate }}
          </label>
        </div>
        <div>
          <label>
            <input
              type="radio"
              formControlName="dateOption"
              value="last7Days"
              (change)="generateQuery(timeGroup.value,true);"
            />
            {{ "time-query.last-7-days" | translate }}
          </label>
        </div>
        <div>
          <label>
            <input
              type="radio"
              formControlName="dateOption"
              value="currentCycle"
              (change)="generateQuery(timeGroup.value,true);"
            />
            {{ "clients.plantings.individual.current-cycle" | translate }}
          </label>
        </div>
      </div>
      <div class="col-12 col-md-6 d-flex justify-content-end align-items-center">
        <div>
          <select
            style="width: 150px"
            name="dataGroup"
            id="dataGroup"
            class="form-control"
            [ngbTooltip]="'time-query.grouping' | translate"
            (change)="generateQuery(timeGroup.value,false)"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="dataAgrupation"
          >
            <option value="M">{{ "filter.month" | translate }}</option>
            <option value="W">{{ "filter.week" | translate }}</option>
            <option value="D">{{ "clients.home.feeding.day" | translate }}</option>
            <option value="H">{{ "filter.hours" | translate }}</option>
          </select>
        </div>
      </div>

      <div class="col-12 col-md-9 d-flex flex-wrap mt-2 align-items-center" style="gap: 20px">
        <label>
          <input
            type="radio"
            formControlName="dateOption"
            value="thisMonth"
            (change)="generateQuery(timeGroup.value,true);"
          />
          {{ "time-query.current-month" | translate }}
        </label>
        <label>
          <input type="radio" formControlName="dateOption" value="specific" />
          {{ "time-query.specific-dates" | translate }}
        </label>
        <ng-container *ngIf="validateTypeSearch(timeGroup.controls.dateOption.value)">
          <div class="flex-item">
            <input
              type="date"
              class="form-control"
              formControlName="start_date"
              (change)="generateQuery(timeGroup.value)"
              ngbTooltip="{{'words.from' | translate}}"
            />
          </div>

          <div class="flex-item">
            <input
              type="date"
              class="form-control"
              formControlName="finish_date"
              ngbTooltip="{{'words.to' | translate}}"
              (change)="generateQuery(timeGroup.value)"
            />
          </div>
        </ng-container>
      </div>

      <div class="col-12 col-md-3 mt-2 align-items-center">
        <ng-container *ngIf="storageService.validateSoloAdmin()">
          <label class="switch m-0 justify-content-around" for="ffill">
            {{ "time-query.fill-fields" | translate }}
            <input
              type="checkbox"
              name="ffill"
              id="ffill"
              [(ngModel)]="ffill"
              (change)="generateQuery(timeGroup.value,false)"
              [ngModelOptions]="{standalone: true}"
            />
            <span class="slider round ml-3"></span>
          </label>
        </ng-container>
      </div>
      <!--    <label>
          <input
            type="radio"
            formControlName="dateOption"
            value="today"
            (change)="generateQuery(timeGroup.value,true);"
          />
          Del día de hoy
        </label>

        <label>
          <input
            type="radio"
            formControlName="dateOption"
            value="thisWeek"
            (change)="generateQuery(timeGroup.value,true);"
          />
          De la semana
        </label>
        -->
    </div>
  </form>
</div>
